import { render, staticRenderFns } from "./AdminSbOptionsList.vue?vue&type=template&id=16efa2c4&scoped=true"
import script from "./AdminSbOptionsList.vue?vue&type=script&lang=js"
export * from "./AdminSbOptionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16efa2c4",
  null
  
)

export default component.exports